import { render } from "./ButtonList.vue?vue&type=template&id=581b9bbf&scoped=true"
import script from "./ButtonList.vue?vue&type=script&lang=js"
export * from "./ButtonList.vue?vue&type=script&lang=js"

import "./ButtonList.vue?vue&type=style&index=0&id=581b9bbf&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581b9bbf"]])

export default __exports__